/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentScheduleRequest extends models.AiAgentScheduleRequestBase {
    constructor() {
        super();
        this.setDiscriminator("AiAgentScheduleRequest");
    }

    getFixupPrototypeFunction() { return AiAgentScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<AiAgentScheduleRequest>): AiAgentScheduleRequest {
        let obj = Object.assign(new AiAgentScheduleRequest(), model);
        AiAgentScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentScheduleRequest>): AiAgentScheduleRequest {
        if (!model) return null;
        return AiAgentScheduleRequest.newInstance(<AiAgentScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentScheduleRequest) {
        if (!obj) return;

        models.AiAgentScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentScheduleRequest): boolean {
        if (models.AiAgentScheduleRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiAgentScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User ID of user who scheduled the report
     */
    created_by: string;

    /**
     * Schedule ID of which the report to be generated
     */
    schedule_id: string;

    /**
     * List of Email IDs for which the scheduled report will be sent.
     */
    email_recipients: Array<string>;

    /**
     * AI agentic feed Report type
     */
    report_type: models.AiAgenticFeedReportType;

}
